import { v4 as uuidv4 } from 'uuid';

export default {
  install(_, { store }) {
    let sessionID = localStorage.getItem('sessionID');
    if (!sessionID) {
      sessionID = uuidv4();
    }
    localStorage.setItem('sessionID', sessionID);
    store.dispatch('auth/setSessionID', { sessionID });
  },
};
